import React, { useState } from 'react'
import UsersForm from './UsersForm'
import { useParams } from 'react-router-dom';

const EditUserPage = () => {
  const { id } = useParams();
  
  
  
  return (
    <>
    currentUserId?(<UsersForm formType='edit' currentUserId={id} ></UsersForm>):''
     
    </>
  )
}

export default EditUserPage
